



















































import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class Liaison extends Vue {
	@Prop()
	private data!: any

	@Prop()
	private notPreview!: boolean

	@Prop()
	private isH5!: boolean

	private contentText: string =
		'尊敬的客户：\n \xa0\xa0\xa0\xa0\xa0\xa0\xa0您好，对于本次报案的情况我们深表关切，请您保管好相关的材料，方便后续的理赔，包括但不限于医药发票、病历、住院证明、报警证明等，如有疑问可联系理赔专员咨询，我们诚挚地希望您早日康复，谢谢！'

	private get contactInfo(): any {
		return this.data.cover && this.data.cover.contactInfo
	}
}
